<template>
  <div>
    <vs-row v-if="loadPayments && product.productOption.includes('pay-now') && (cardEnabled || product.eftEnabled)" class="mb-8">
      <vs-col vs-w="12" class="flex items-center">
        <div class="flex justify-center items-center" style="max-width: 20px">
          <feather-icon icon="CodepenIcon" class="text-grey-outline" />
        </div>
        <h5 class="ml-5 mb-0">Payments</h5>
      </vs-col>
      <vs-col vs-w="12">
        <hr class="line-hr mt-2 mb-4" />
      </vs-col>

      <vs-col vs-w="12" class="onboarding-form">
        <div class="flex flex-wrap">
          <div class="md:col-start-3 md:col-end-11 bg-container-80">
            <p class="text-body mb-10">Available payment methods and corresponding transaction fees are listed below.</p>
            <div class="flex justify-between">
              <h5 class="w-185">Payment method</h5>
              <h5 class="w-12">Fee</h5>
            </div>

            <hr class="mb-6" />

            <div class="grid gap-y-3" v-if="product.payNowOptions.includes('CARDS') && cardEnabled">
              <div class="flex items-center justify-between" :key="index" v-for="(card, index) in product.payNowPaymentMethods">
                <div class="flex items-center gap-x-4 w-200">
                  <img v-if="card.title.toLowerCase() == 'visa'" :src="visaCard" alt="visa" />
                  <img v-else-if="card.title.toLowerCase() == 'mastercard'" :src="masterCard" alt="masterCard" />
                  <img v-else-if="card.title.toLowerCase() == 'american express'" :src="amexCard" alt="amex" />
                  <img v-else-if="card.title.toLowerCase() == 'diners club'" :src="dinersClubCard" alt="diners-club" />
                  <img v-else-if="card.title.toLowerCase() == 'china unionpay'" :src="unionPayCard" alt="unionPay" />
                  <p>{{ card.title }}</p>
                </div>
                <p>{{ `${addZeroes(card.surcharge)} %` }}</p>
              </div>
            </div>

            <div class="grid mt-3" v-if="product.payNowOptions.includes('EFT') && product.eftEnabled">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-x-4">
                  <img :src="payId" alt="payId" height="20" width="50" />
                  <p>EFT via {{appName}} virtual account</p>
                </div>
                <p class="w-12">Free</p>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <vs-row v-if="product.productOption.includes('pay-later')">
      <vs-col vs-w="12" class="flex items-center ml-1">
        <div class="flex justify-center items-center" style="max-width: 20px">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fil
              l-rule="evenodd"
              clip-rule="evenodd"
              d="M8.71258 0.673082C8.98875 0.493575 9.34473 0.493575 9.6209 0.673082L17.9542 6.08975C18.1907 6.24347 18.3334 6.50639 18.3334 6.78845V12.6218C18.3334 12.9038 18.1907 13.1668 17.9542 13.3205L9.6209 18.7372C9.34473 18.9167 8.98875 18.9167 8.71258 18.7372L0.379248 13.3205C0.142754 13.1668 7.15796e-05 12.9038 7.15796e-05 12.6218V6.78845C7.15796e-05 6.50639 0.142754 6.24347 0.379248 6.08975L8.71258 0.673082ZM1.66674 7.24069V12.1695L9.16674 17.0445L16.6667 12.1695V7.24069L9.16674 2.36569L1.66674 7.24069Z"
              fill="#BDBDBD"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.16674 11.7885C9.62698 11.7885 10.0001 12.1615 10.0001 12.6218V18.0385C10.0001 18.4987 9.62698 18.8718 9.16674 18.8718C8.7065 18.8718 8.33341 18.4987 8.33341 18.0385V12.6218C8.33341 12.1615 8.7065 11.7885 9.16674 11.7885Z"
              fill="#BDBDBD"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.150712 6.31057C0.41464 5.93353 0.934249 5.84183 1.31129 6.10576L9.16674 11.6046L17.0222 6.10576C17.3992 5.84183 17.9188 5.93353 18.1828 6.31057C18.4467 6.68761 18.355 7.20722 17.978 7.47114L9.64462 13.3045C9.35769 13.5053 8.97579 13.5053 8.68885 13.3045L0.35552 7.47114C-0.0215215 7.20722 -0.113217 6.68761 0.150712 6.31057Z"
              fill="#BDBDBD"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.68885 6.10576C8.97579 5.9049 9.35769 5.9049 9.64462 6.10576L17.978 11.9391C18.355 12.203 18.4467 12.7226 18.1828 13.0997C17.9188 13.4767 17.3992 13.5684 17.0222 13.3045L9.16674 7.80566L1.31129 13.3045C0.934249 13.5684 0.41464 13.4767 0.150712 13.0997C-0.113217 12.7226 -0.0215215 12.203 0.35552 11.9391L8.68885 6.10576Z"
              fill="#BDBDBD"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.16674 0.538452C9.62698 0.538452 10.0001 0.911548 10.0001 1.37179V6.78845C10.0001 7.24869 9.62698 7.62178 9.16674 7.62178C8.7065 7.62178 8.33341 7.24869 8.33341 6.78845V1.37179C8.33341 0.911548 8.7065 0.538452 9.16674 0.538452Z"
              fill="#BDBDBD"
            />
          </svg>
        </div>
        <h5 class="ml-5 mb-0">Finance options</h5>
      </vs-col>
      <hr class="line-hr mb-8 mt-2 w-full ml-1" />
      <vs-col vs-w="12" class="onboarding-form">
        <vs-row class="grid grid-cols-3 paymentOpt">
          <vs-col v-for="(payLaterPlan, key) in product.payLaterProducts" :key="key" class="w-auto">
            <div class="radio-card w-full" v-if="payLaterPlan.isChecked">
              <vs-row>
                <vs-col vs-w="10" vs-sm="10" vs-lg="10" vs-xs="10" class="radio-label">{{ payLaterPlan.productName }}</vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-w="12" vs-sm="12" vs-lg="12" vs-xs="12">
                  <div>
                    <span class="flex items-center">
                      <p class="text-xs">Service fee:</p>
                      <h6 class="ml-2 text-xs">{{ addZeroes(parseFloat(payLaterPlan.msf)) }} %</h6>
                      <span class="text-xs ml-1">{{ payLaterPlan.feeModel == "MSF_INCLUDED" ? "(payable by you)" : "(payable by customer)" }}</span>
                    </span>
                    <span class="flex items-center" v-if="payLaterPlan.minimumFeeAmount > 0">
                      <p class="text-xs">Minimum fee:</p>
                      <h6 class="ml-2 text-xs">$ {{ addZeroes(parseFloat(payLaterPlan.minimumFeeAmount)) }}</h6>
                    </span>

                    <span class="flex items-center" v-if="payLaterPlan.initialPeriod">
                      <p class="text-xs">Period:</p>
                      <h6 class="ml-2 text-xs">{{ payLaterPlan.initialPeriod }} days</h6>
                    </span>

                    <span class="flex items-center" v-if="payLaterPlan.noOfPayments">
                      <p class="text-xs">Schedule:</p>
                      <h6 class="ml-2 text-xs">{{ `${payLaterPlan.noOfPayments} payments, ${payLaterPlan.paymentFrequency.toLowerCase()}` }}</h6>
                    </span>

                    <span class="flex items-center">
                      <p class="text-xs">Limit per request:</p>
                      <h6 class="ml-2 text-xs">$ {{ addZeroes(parseFloat(payLaterPlan.maximumAmount)) }}</h6>
                    </span>

                    <span class="flex items-center mb-6">
                      <p class="text-xs"><a class="text-base font-light" @click="handleTermsClick(payLaterPlan.customPlanId)">Terms & conditions</a></p>
                    </span>

                    <template v-if="payLaterPlan.banks && payLaterPlan.banks.length > 0 && !(payLaterPlan.productConfigType === 'THREE_PARTY' && payLaterPlan.disburseTo == 'external')">
                      <p class="mt-2">Linked bank accounts</p>
                      <template v-for="(bank, index) in getBanks(payLaterPlan.banks)">
                        <div :key="index" class="mt-2">
                          <span class="font-bold">Bank {{ index+ 1 }}</span><br>
                          <span>Account name:</span> <span>{{ bank.accountName }}</span><br>
                          <span>Bsb:</span> <span>{{ bank.bsb }}</span><br>
                          <span>Account number:</span> <span>{{ bank.accountNumber }}</span><br>
                        </div>
                      </template>
                    </template>
                  </div>
                </vs-col>
              </vs-row>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
const payId = require("@/assets/images/cards/payid.svg");
const amexCard = require("@/assets/images/cards/amex.svg");
const dinersClubCard = require("@/assets/images/cards/dinersclub.svg");
const directDebitCard = require("@/assets/images/cards/directdebit.svg");
const masterCard = require("@/assets/images/cards/mastercard.svg");
const unionPayCard = require("@/assets/images/cards/unionpay.svg");
const visaCard = require("@/assets/images/cards/visa.svg");

export default {
  name: "ProductSelection",

  props: {
    product: { type: Object },
    userId: { type: String },
    showEditButton: { type: Boolean },
    status: { type: String },
    resubmitChanges: { type: Array },
    banks: { type: Array },
  },

  data() {
    return {
      appName: process.env.VUE_APP_NAME == "FlipPay" ? "Flip" : "Rello",
      payId: payId,
      cardEnabled: false,
      amexCard: amexCard,
      dinersClubCard: dinersClubCard,
      directDebitCard: directDebitCard,
      masterCard: masterCard,
      unionPayCard: unionPayCard,
      visaCard: visaCard,
      loadPayments: false,
    }
  },

  methods: {
    handleTermsClick(planId) {
      window.open(`${process.env.VUE_APP_ROOT_API}products/${planId}/borrower`, "_blank");
    },

    addZeroes(num) {
      num = String(num);
      return Number(num).toLocaleString(undefined, {
        minimumFractionDigits: 2,
      });
    },

    getChanges(index, flag) {
      if (this.resubmitChanges.length > 0 && this.status == "Resubmitted") {
        let changedlabel = `payNowPaymentMethods[${index}]${flag}`;
        let objData = this.resubmitChanges.findIndex((obj) => obj.label === changedlabel);

        if (objData >= 0) {
          return true;
        }
      }

      return false;
    },

    getBanks(bsb) {
      if (!bsb || !bsb.length) {
        return [];
      }

      let banks = [];

      bsb.forEach(item => {
        const filter = item.split("/");

        const bank = this.banks.find(element => {
          if (filter && filter.length && filter.length > 1) {
            return (element.bsb == filter[0] && element.accountNumber == filter[1] && element.accountName == filter[2]);
          } else {
            return element.bsb == filter[0];
          }
        });

        if (bank) {
          banks.push(bank);
        }
      });

      return banks;
    }
  },

  mounted() {
    this.cardEnabled = this.product.payNowPaymentMethods.some((item) => item.isChecked);

    if (!this.product.payNowOptions && this.product.productOption.includes("pay-now")) {
      this.product.payNowOptions = ["CARDS", "EFT"];
      this.product.eftEnabled = true;
    }

    this.loadPayments = true;
  }
};
</script>

